export default {"src":"/_next/static/media/facebook.edc95c46.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};